import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
  private currentUser: any;
  private token: any;
  constructor(private router: Router, private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = JSON.parse(localStorage.getItem('currentUser'));

    if (user && user.token) {
      request = request.clone({
        headers: request.headers.set('Authorization', 'Token ' + user.token)
      });
    }

    const isFormData = request.body instanceof FormData;
    const isLoginRequest = request.url.includes('/authenticate');

    if (!isFormData && !isLoginRequest) {
      if (!request.headers.has('Content-Type')) {
        request = request.clone({
          headers: request.headers.set('Content-Type', 'application/vnd.api+json')
        });
      }
      request = request.clone({
        headers: request.headers.set('Accept', 'application/vnd.api+json')
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((error: HttpErrorResponse) => throwError(error))
    );
  }



}
